import routes from './routes.json'
import shared from './shared.json'
import pages from './pages.json'
import auth from './auth.json'
import user from './user.json'
import fat from './fat.json'
import resReq from './res-req.json'
import city from './city.json'
import guide from './guide.json'
import restaurants from './restaurants.json'
import restaurant from './restaurant.json'
import giftcards from './giftcards.json'
import events from './events.json'
import offers from './offers.json'
import campaigns from './campaigns.json'
import error from './error.json'

export default {
  routes,
  shared,
  pages,
  auth,
  user,
  fat,
  resReq,
  city,
  guide,
  restaurants,
  restaurant,
  giftcards,
  events,
  offers,
  campaigns,
  error
}
